import { useInternalOpsChannel } from "@/lib/api/internal-ops-messaging";
import { ChannelProvider } from "@sendbird/uikit-react/Channel/context";
import { Moodies } from "@somethings-ui/core/assets";
import { ArrowLeft, X } from "lucide-react";
import { useMemo } from "react";
import { ChannelHeader } from "../conversations/channel-header";
import { MessageInput } from "../conversations/message-input";
import { ChannelDetails } from "../sendbird-chat/channel-details";

interface ChatDetailProps {
  currentChannelUrl: string | null;
  internalChannelId: string | null;
  onBack: () => void;
  onClose: () => void;
}

export const ChatDetail = ({
  currentChannelUrl,
  internalChannelId,
  onBack,
  onClose,
}: ChatDetailProps) => {
  const { data: opsChannel } = useInternalOpsChannel(internalChannelId);

  const opsContext = useMemo(
    () => ({ internalChannelId: opsChannel?.id ?? internalChannelId }),
    [opsChannel?.id, internalChannelId],
  );

  const opsTitle = useMemo(() => {
    if (!opsChannel) return null;
    if (opsChannel.kind === "direct") return null;
    return opsChannel.channel_display_name ?? null;
  }, [opsChannel]);

  const opsAvatar = useMemo(() => {
    if (opsChannel?.kind !== "cohort") return undefined;
    return (
      <img
        src={Moodies.happy}
        alt="Cohort"
        className="size-10 shrink-0 object-contain"
      />
    );
  }, [opsChannel?.kind]);

  if (!currentChannelUrl) {
    return null;
  }

  return (
    <ChannelProvider channelUrl={currentChannelUrl} replyType="QUOTE_REPLY">
      <ChannelDetails
        currentChannelUrl={currentChannelUrl}
        channelHeader={
          <ChannelHeader
            isSupervisorChannel
            titleOverride={opsTitle}
            avatarOverride={opsAvatar}
            leftElement={
              <button
                className="rounded-full p-1 hover:bg-gray-100"
                onClick={onBack}
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
            }
            opsChannel={opsChannel ?? null}
            rightElement={
              <button
                className="rounded-full p-1 hover:bg-gray-100"
                onClick={onClose}
              >
                <X className="h-5 w-5" />
              </button>
            }
          />
        }
        messageInput={
          <MessageInput
            shouldShowAiConversation={false}
            shouldShowVideoCallButton={false}
            isSupervisorView={true}
            opsContext={opsContext}
          />
        }
      />
    </ChannelProvider>
  );
};
